<template lang="pug">
    v-card
        //crud-create-button.auth(
            text="Publicar"
            icon="done_all"
            :buttonProps="{color:'success'}"
            v-if="isAccountingSeatAuthorizedPublish && $can('AUTHORIZE_CONFIRM_ACCOUNTING_SEAT')"
            :action="actionAuthorizedAccountingSeat"
            )
        //crud-create-button(
            text="Rechazar"
            icon="assignment_late"
            :buttonProps="{color:'error'}"
            v-if="isAccountingSeatAuthorizedReject && $can('AUTHORIZE_CONFIRM_ACCOUNTING_SEAT')"
            :action="actionRefuseAccountingSeat"
            )
        crud-form(
            :fields="fields"
            @reset='loadAsyncFormData'
            @submitForm="submitUpdateAccountingSeat($event)"
            :editable="isEditable"
            @editable="submitEditableCF($event)"
            :noButtons="!isEditable"
            readOnly
            ref="refCrudFormShowAccountingSeat"
            submitText="Guardar"
            form-title='Detalle de asiento contable'
            )
            template(
                slot="appendContent"
                )
                create-voucher-table(
                    :headers="headers"
                    :items="items"
                    @items:change="items = $event"
                    ref="voucher-table"
                    :lock="isLock"
                    :accounts="accounts"
                    :accountTypes="accountTypes"
                    :costCenters="costCenters"
                    )
</template>

<script>
import { CrudForm, CrudCreateButton } from '@/components/reusable_components'
import { ShowFields as fields } from './fields'
import { CreateHeaders as headers } from './headers'
import { CreateVoucherTable } from './partials'
import { mapState, mapActions } from 'vuex'
import { InputValidations } from '@/mixins/reusable_mixins'
import {
    getAllConcepts,
    getAllTypes,
    findAccountingSeat,
    accountingSeatReject,
    accountingSeatPublish,
    updateAccountingSeat,
} from '../../services/api/accountingSeat'
import { getAllAccounts, getAllAccountTypes } from '../../services/api/account'
import { getAllCostCenter } from '@/services/api/costCenter'
export default {
    name: 'show-voucher',
    props: {},
    data: function() {
        return {
            fields: fields,
            headers: headers,
            items: [],
            lock: true,
            accounts: [],
            accountTypes: [],
            loading: false,
            accountingSeat: {
                code: '',
            },
            isAccountingSeatAuthorizedPublish: false,
            isAccountingSeatAuthorizedReject: false,
            editableValue: false,
            isLock: true,
            totalDebitAmount: 0,
            costCenters: [],
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        actionAuthorizedAccountingSeat() {
            let authorized = () => {
                this.resetSnackbarState()
                let totalAmount = this.totalDebitAmount
                let totalExpected = this.accountingSeat.expected_amount
                if (
                    totalExpected === 0 ||
                    (totalAmount > 0 && totalAmount === totalExpected)
                ) {
                    this.setMessageConfirmSnack('Publicar')
                    let payload = this.fillSnack(
                        'warning',
                        '¿Desea publicar/autorizar asiento contable?',
                        ''
                    )
                    this.initSnackbar(payload)
                } else {
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'info',
                        'Balance esperado debe coincidir con total de asiento contable',
                        ''
                    )
                }
            }
            return authorized
        },
        actionRefuseAccountingSeat() {
            let refuse = () => {
                this.resetSnackbarState()
                this.setMessageConfirmSnack('Rechazar')
                let payload = this.fillSnack(
                    'warning',
                    '¿Desea rechazar asiento contable?',
                    ''
                )
                this.initSnackbar(payload)
            }
            return refuse
        },
        isEditable: {
            get: function() {
                return this.editableValue && this.$can('EDIT_ACCOUNTING_SEAT')
            },
            set: function(val) {
                this.editableValue = val
            },
        },
    },
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        showSnackbar: function(type, title, message) {
            this.initSnackbar(this.fillSnack(type, title, message))
        },
        // UI Modifiers
        toggleLoading(bool) {
            this.fields = [
                ...this.fields.map(fld => {
                    fld.vuetifyProps.loading = bool
                    return fld
                }),
            ]
        },
        submitUpdateAccountingSeat: async function(event) {
            let vouchersData = this.items
            let request = this.toBackendFormat(event, vouchersData)
            this.resetSnackbarState()
            //-
            let response = await updateAccountingSeat(
                this.$route.params.id,
                request
            )
            if (
                response.status === 'success' ||
                [200, 201].includes(response.http_status_code)
            ) {
                this.successSnackbar('Datos guardados correctamente')
                this.$router.push('/accounting_records')
            } else {
                this.errorSnackbar(response.message)
            }
        },
        // Validations and Errors
        validateResponse: function(response) {
            if (response.status && ![200, 201].includes(response.status)) {
                throw {
                    name: 'FetchDataError',
                    message: 'Error al cargar información desde base de datos',
                }
            }
        },
        // Generic Snackbars
        warningSnackbar(message) {
            this.initSnackbar(
                this.fillSnack('warning', 'Error en formularios', message)
            )
        },
        successSnackbar(message) {
            this.initSnackbar(this.fillSnack('success', 'Éxito', message))
        },
        errorSnackbar(message) {
            this.initSnackbar(this.fillSnack('error', 'Error', message))
        },
        // Data fetching methods
        toBackendFormat: function(formData, vouchersList) {
            let data = {}
            data.comment = formData.comment
            data.accounting_date = formData.date
            data.expected_amount = formData.expected_amount || 0
            data.acc_accounting_seat_concept_id =
                formData.acc_accounting_seat_concept_id
            data.acc_accounting_seat_type_id =
                formData.acc_accounting_seat_type_id
            data.debits = []
            data.credits = []
            vouchersList.forEach(voucher => {
                if (voucher.debt && voucher.debt !== 0) {
                    data.debits.push({
                        acc_account_id: voucher.acc,
                        amount: voucher.debt,
                        ref_document: voucher.ref_document,
                        description: voucher.description,
                        acc_cost_center_id: voucher.cost_center,
                    })
                } else if (voucher.receive && voucher.receive !== 0) {
                    data.credits.push({
                        acc_account_id: voucher.acc,
                        amount: voucher.receive,
                        ref_document: voucher.ref_document,
                        description: voucher.description,
                        acc_cost_center_id: voucher.cost_center,
                    })
                }
            })
            return data
        },
        loadAccSeat: async function() {
            let response = await findAccountingSeat(this.$route.params.id)
            this.validateResponse(response)
            this.accountingSeat = response
            this.isAuthorized(response)
            this.isEditSwitchEditable(response)
        },
        loadSeatTypes: async function() {
            let response = await getAllTypes()
            this.validateResponse(response)
            this.fields[3].options.data = response.data
        },
        loadSeatConcepts: async function() {
            let response = await getAllConcepts()
            this.validateResponse(response)
            this.fields[5].options.data = response.data
        },
        loadAccounts: async function() {
            let response = await getAllAccounts()
            this.validateResponse(response)
            this.accounts = response.data
        },
        loadAccountTypes: async function() {
            let response = await getAllAccountTypes()
            this.validateResponse(response)
            this.accountTypes = response.data
        },
        loadCostCenter: async function() {
            let response = await getAllCostCenter()
            this.validateResponse(response)
            this.costCenters = response.data
        },
        loadAsyncFormData: function() {
            this.loading = true
            Promise.all([
                this.loadAccSeat(),
                this.loadSeatTypes(),
                this.loadSeatConcepts(),
                this.loadAccounts(),
                this.loadAccountTypes(),
                this.loadCostCenter(),
            ])
                .then(rs => {
                    this.assignAccSeatData()
                    this.assignItemsData()
                    this.setTitleTopBar(
                        `Detalles asiento ${this.accountingSeat.code}`
                    )
                })
                .catch(err => {
                    this.errorSnackbar(err.message)
                })
            this.loading = false
        },
        // Data assignin methods
        submitEditableCF: function(e) {
            switch (e.editable) {
                case true:
                    this.isLock = false
                    this.isAccountingSeatAuthorizedPublish = false
                    this.isAccountingSeatAuthorizedReject = false
                    break
                case false:
                    this.isLock = true
                    this.isAuthorized(this.accountingSeat)
                    break
            }
        },
        isAuthorized: function(data) {
            //- Publish
            if (data.acc_accounting_seat_status.status === 'Sin Asentar') {
                if (data.acc_credits.length > 0 && data.acc_debits.length > 0) {
                    let totalDebits = data.acc_debits
                        .map(debit => parseFloat(debit.pivot.amount))
                        .reduce((total, debt) => total + debt)
                    let totalCredits = data.acc_credits
                        .map(credit => parseFloat(credit.pivot.amount))
                        .reduce((total, credt) => total + credt)
                    this.totalDebitAmount = totalDebits
                    this.isAccountingSeatAuthorizedPublish =
                        totalDebits != totalCredits ? false : true
                } else {
                    this.isAccountingSeatAuthorizedPublish = false
                }
            } else {
                this.isAccountingSeatAuthorizedPublish = false
            }
            //- Reject
            this.isAccountingSeatAuthorizedReject =
                data.acc_accounting_seat_status.status === 'Sin Asentar'
                    ? true
                    : false
        },
        isEditSwitchEditable: function(data) {
            this.isEditable =
                data.acc_accounting_seat_status.status === 'Sin Asentar'
                    ? true
                    : false
        },
        assignAccSeatData: function() {
            const fullName = hr_employee => {
                return `${hr_employee.names} ${hr_employee.last_name1}`
            }
            let fields = [...this.fields]
            let {
                code,
                g_generator_user,
                accounting_date,
                acc_accounting_seat_type_id,
                expected_amount,
                acc_accounting_seat_concept_id,
                comment,
            } = this.accountingSeat
            fields[0].value = code
            fields[1].value = fullName(g_generator_user.hr_employee)
            fields[2].value = accounting_date
            fields[3].value = acc_accounting_seat_type_id
            fields[4].value = expected_amount
            fields[5].value = acc_accounting_seat_concept_id
            fields[6].value = comment

            let items = []

            if(this.isAccountingSeatAuthorizedPublish && this.$can('AUTHORIZE_CONFIRM_ACCOUNTING_SEAT')) {
                items.push({
                    color: 'success',
                    text: 'Publicar',
                    icon: 'done_all',
                    action: this.actionAuthorizedAccountingSeat,
                })
            }

            if(this.isAccountingSeatAuthorizedReject && this.$can('AUTHORIZE_CONFIRM_ACCOUNTING_SEAT')) {
                items.push({
                    color: 'error',
                    text: 'rechazar',
                    icon: 'assignment_late',
                    action: this.actionRefuseAccountingSeat,
                })
            }
            this.setItems(items)
            this.fields = fields
        },
        assignItemsData: function() {
            let items = []
            let { acc_credits, acc_debits } = this.accountingSeat
            items = [
                ...acc_debits.map(deb => this.formatAccount(deb, 'debit')),
                ...acc_credits.map(cred => this.formatAccount(cred, 'credit')),
            ]
            this.items = [...items]
        },
        formatAccount: function(acc, type) {
            let {
                acc_account_id,
                acc_cost_center_id,
                ref_document,
                description,
                amount,
            } = acc.pivot
            let obj = {}
            obj.acc = acc_account_id
            obj.cost_center = acc_cost_center_id
            obj.ref_document = ref_document
            obj.description = description
            if (type === 'debit') {
                obj.debt = amount
                obj.receive = 0
            } else {
                obj.debt = 0
                obj.receive = amount
            }
            return obj
        },

        /**
         * 
         */
        clean() {
            fields[0].value = ''
            fields[1].value = ''
            fields[2].value = ''
            fields[3].value = ''
            fields[4].value = ''
            fields[5].value = ''
            fields[6].value = ''
        }
    },
    watch: {
        loading: {
            inmediate: true,
            handler: function(val) {
                this.toggleLoading(val)
            },
        },
        async responseConfirm(val) {
            //-
            if (val === 'Rechazar') {
                this.resetSnackbarState()
                let response = await accountingSeatReject(this.$route.params.id)
                //
                if (response.status == 'success') {
                    this.showSnackbar(
                        'success',
                        'Asiento contable ha sido rechazado correctamente',
                        ''
                    )
                    this.$router.push('/accounting_records')
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            } else if (val === 'Publicar') {
                this.resetSnackbarState()
                this.resetSnackbarState()
                let response = await accountingSeatPublish(
                    this.$route.params.id
                )
                //
                if (response.status == 'success') {
                    this.showSnackbar(
                        'success',
                        'Asiento contable ha sido publicado exitosamente',
                        ''
                    )
                    this.$router.push('/accounting_records')
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        'crud-form': CrudForm,
        'crud-create-button': CrudCreateButton,
        'create-voucher-table': CreateVoucherTable,
    },
    mixins: [InputValidations],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    created: function() {
        this.setTitleTopBar('Detalles asiento')
        this.clean()
        this.loadAsyncFormData()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_ACCOUNTING_SEAT')) ctx.$router.push('/')
        })
    },
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
    mounted() {
    }
}
</script>

<style lang="scss" scoped>
h1.hide {
    opacity: 0;
}
.auth {
    right: 260px;
}
</style>
